import historicalArbitrageOrderDetailInquiry from './historical-arbitrage-order-detail-inquiry.vue'
export default historicalArbitrageOrderDetailInquiry
